import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7 17v5h10v-5H7z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v13h10V4z"
})), 'Battery20Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Battery20Sharp.js
// module id = 2246
// module chunks = 2